import { Link } from "react-router-dom";
import { useSeo } from "@/lib/useSeo";
import { IMG } from "@/lib/images";
import { PageHeader, Section, Prose, Quote } from "@/components/Editorial";

const INTERESTS = [
  "l'histoire de l'ésotérisme", "les arts divinatoires", "les croyances", "les symboles",
  "les légendes", "le mysticisme", "les pratiques spirituelles", "l'histoire de France sous un angle inhabituel",
  "les anecdotes historiques attestées", "les personnages historiques liés à l'occultisme ou au mysticisme",
  "les pierres des couronnes royales et leur symbolique", "les pratiques populaires", "les phénomènes étranges",
  "les récits autour de la mort et du deuil", "le rêve", "l'inconscient", "la transmission",
];

const VALUES = ["la transmission", "la curiosité", "l'esprit critique", "la recherche", "le contexte historique", "le doute raisonnable", "la distinction entre fait, croyance et légende"];

export default function About() {
  useSeo({
    title: "À propos — Qui est Dorothée Lancelot ?",
    description: "Dorothée Lancelot est auteure, médium, conférencière et onirothérapeute. Une approche de l'ésotérisme par son histoire, son origine et son contexte.",
    path: "/a-propos",
  });

  return (
    <div>
      <PageHeader eyebrow="Biographie" title="Qui est Dorothée Lancelot ?" image={IMG.portrait} tall />

      <Section>
        <Prose>
          <p className="text-xl text-[#F3E9D2]">
            Dorothée Lancelot est auteure, médium, conférencière et onirothérapeute. Son nom s'est construit
            au fil des années autour de plusieurs univers : l'écriture, la transmission, l'ésotérisme,
            l'histoire, le rêve et l'accompagnement du deuil.
          </p>
          <p>
            Elle aborde l'ésotérisme avec une approche particulière : ne pas seulement parler de pratique,
            mais comprendre son origine, son évolution, son contexte historique et ce que les sociétés en ont fait.
          </p>
          <p>
            Une communauté fidèle suit son travail, ses publications, ses conférences et ses différents projets.
            Son travail se décline à travers des livres, des conférences, des rencontres publiques, des contenus
            diffusés sur les réseaux et plusieurs projets éditoriaux.
          </p>
        </Prose>

        <Quote>« Avant de pratiquer, comprenons d'où ça vient. »</Quote>

        <div className="mt-10">
          <div className="dl-eyebrow mb-5">Elle s'intéresse notamment à</div>
          <div className="flex flex-wrap gap-2.5 max-w-4xl">
            {INTERESTS.map((t, i) => (
              <span key={i} className="px-4 py-2 text-sm border border-[rgba(198,167,106,0.25)] text-[#F3E9D2]/75 first-letter:capitalize">{t}</span>
            ))}
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-12">
          <Prose>
            <p>
              Elle refuse de réduire l'ésotérisme à une tendance ou à quelques vidéos courtes. Elle défend une
              lecture patiente, documentée, qui replace chaque pratique dans son époque et son histoire.
            </p>
          </Prose>
          <div>
            <div className="dl-eyebrow mb-5">Ce qu'elle défend</div>
            <ul className="space-y-3">
              {VALUES.map((v, i) => (
                <li key={i} className="text-[#F3E9D2]/80 flex items-start gap-3 first-letter:capitalize">
                  <span className="text-[#C6A76A] mt-1">—</span> {v}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-wrap gap-4">
          <Link to="/livres" className="dl-btn dl-btn-solid">Découvrir ses livres</Link>
          <Link to="/conferences" className="dl-btn">Ses conférences</Link>
        </div>
      </Section>
    </div>
  );
}
